const _clientConfig = [];
_clientConfig['stg'] = {
  'client_id': '6jfrij40sqsbp214eqn495tc59',
  'identity_pool_id': 'us-east-1:2d0791e2-939d-4e11-a50f-db0ba751b056',
  'region': 'us-east-1',
  'user_pool_id': 'us-east-1_r5DGAqeMi',
  'api_url': 'https://7ky7ehj58f.execute-api.us-east-1.amazonaws.com/stg',
  's3_region': 'us-east-1',
  'bucket': 'otaglobal-ota-files-stg-us-east-1-bucket'
};
const clientConfig = _clientConfig[process.env.REACT_APP_PUBLISH_ENV];
export default clientConfig;
